// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as AuthRoutes from "./AuthRoutes.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-xugmn4g",
    "width-kzqmXN": "width-x2cbyk5",
    $$css: "wino-gc:src/app/Auth/AuthUsernameUpdatePage.res.js:22"
  },
  title: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "paddingBlock-k8WAf4": "paddingBlock-xqp6ajr",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthUsernameUpdatePage.res.js:31"
  }
};
let endpoint = Env.gatewayUrl() + "/auth/username";
function encodeBody(tokenId, token, userId, username) {
  return Json.encodeDict(Object.fromEntries([["token", Json.encodeString(token)], ["tokenId", Json.encodeString(tokenId)], ["userId", Json.encodeString(userId)], ["username", Json.encodeString(username)]]));
}
function decodeInvalidRequestFailure(error) {
  switch (error.kind) {
    case "DuplicateUserUsername":
      return "DuplicateUserUsername";
    case "ExpiredOneTimeToken":
      return "ExpiredOneTimeToken";
    case "NotFoundUsernameUpdateOneTimeToken":
      return "NotFoundUsernameUpdateOneTimeToken";
    default:
      return "UnknownServerFailure";
  }
}
function make(token, tokenId, userId, username) {
  return Future.mapError(Request.make(endpoint, "PATCH", {
    TAG: "JsonBody",
    _0: encodeBody(tokenId, token, userId, username)
  }, false, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure);
    }
  });
}
let AuthUsernameUpdateRequest = {
  endpoint: endpoint,
  encodeBody: encodeBody,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  make: make
};
function AuthUsernameUpdatePage$NotificationBanner(props) {
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: props.notification,
      onRequestClose: props.onRequestClose
    }),
    spaceTop: "medium"
  });
}
let make$1 = React.memo(AuthUsernameUpdatePage$NotificationBanner);
let NotificationBanner = {
  make: make$1
};
function AuthUsernameUpdatePage(props) {
  let usernameUpdateRequest = props.usernameUpdateRequest;
  let username = props.username;
  let token = props.token;
  let tokenId = props.tokenId;
  let userId = props.userId;
  let navigate = Navigation.useNavigate();
  let auth = Auth.useState();
  let unlogUser = Auth.useUnlogUser();
  let match = React.useState(() => {});
  let setNotfication = match[1];
  let notification = match[0];
  let match$1 = React.useState(() => false);
  let setRedirectToLogin = match$1[1];
  let redirectToLogin = match$1[0];
  React.useEffect(() => {
    Future.get(usernameUpdateRequest(token, tokenId, userId, username), result => {
      if (result.TAG === "Ok") {
        return setRedirectToLogin(param => true);
      }
      let match = result._0;
      if (match !== undefined) {
        let exit = 0;
        switch (match) {
          case "ExpiredOneTimeToken":
          case "NotFoundUsernameUpdateOneTimeToken":
            exit = 2;
            break;
          case "DuplicateUserUsername":
            return setNotfication(param => ({
              TAG: "Danger",
              _0: I18n.t("This email address is already used.")
            }));
          case "UnknownServerFailure":
            break;
        }
        if (exit === 2) {
          return setNotfication(param => ({
            TAG: "Danger",
            _0: I18n.t("The link has expired")
          }));
        }
      }
      let danger = I18n.t("An unexpected error occured. Please try again or contact the support.");
      setNotfication(param => ({
        TAG: "Danger",
        _0: danger
      }));
    });
  }, []);
  React.useEffect(() => {
    if (redirectToLogin) {
      if (typeof auth !== "object") {
        navigate(undefined, AuthRoutes.loginUsernameUpdateSuccessRoute + "/" + username + "/");
      } else if (auth.TAG !== "Logging") {
        unlogUser();
        navigate(undefined, AuthRoutes.loginUsernameUpdateSuccessRoute + "/" + username);
      }
    }
  }, [redirectToLogin, auth]);
  let onRequestCloseNotificationBanner = () => setNotfication(param => {});
  let onPressBackButton = param => navigate(undefined, AuthRoutes.baseRoute);
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-xugmn4g width-x2cbyk5",
      "data-style-src": "wino-gc:src/app/Auth/AuthUsernameUpdatePage.res.js:22"
    }
  };
  let newrecord$1 = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xqp6ajr width-xh8yej3",
      "data-style-src": "wino-gc:src/app/Auth/AuthUsernameUpdatePage.res.js:31"
    }
  };
  newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(Title.make, {
    children: I18n.t("Email update"),
    level: 1
  }), newrecord$1)), notification !== undefined ? JsxRuntime.jsx(make$1, {
    notification: notification,
    onRequestClose: onRequestCloseNotificationBanner
  }) : JsxRuntime.jsx(Spinner.make, {
    size: 16
  }), JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Button.make, {
      label: I18n.t("Back"),
      onPress: onPressBackButton
    }),
    spaceTop: "xxlarge"
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let usernameUpdateRequest = make;
let make$2 = AuthUsernameUpdatePage;
export { styles, AuthUsernameUpdateRequest, usernameUpdateRequest, NotificationBanner, make$2 as make };
/* styles Not a pure module */